import { render, staticRenderFns } from "./CovidCertificate.vue?vue&type=template&id=0cbbbc4c&"
import script from "./CovidCertificate.vue?vue&type=script&lang=js&"
export * from "./CovidCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports